module.exports = __webpack_public_path__ + "static/media/r2hlogo.386408ba.jpg";